import styled from "styled-components";

export const Banner = styled.section`
  margin-top: 0;
  margin-bottom: 0;
  padding: 16px 24px;
  background: ${({ theme }) => theme.tertiary300};
`;
